import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { EditCharterComponent } from './edit.component';
import { EditCharterRoutingModule } from './edit-routing.module';
import { EditCharterResolve } from './edit.resolve';
import { SharedModule } from '../../../shared/shared.module';
import { AppCalendarModule } from '../../../shared/calendar/app-calendar.module';
import { EditCharterCustomerInfoHeadingModule } from '../edit-charter-customer-info-heading/edit-charter-customer-info-heading.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HelpDialogModule } from '../../../public/help-dialog/help-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    MatDialogModule,
    MatListModule,
    MatRadioModule,
    MatDatepickerModule,
    EditCharterRoutingModule,
    SharedModule,
    MatIconModule,
    AppCalendarModule,
    MatExpansionModule,
    HelpDialogModule,
    EditCharterCustomerInfoHeadingModule,
    MatTooltipModule,
  ],
  declarations: [EditCharterComponent],
  entryComponents: [],
  exports: [EditCharterComponent],
  providers: [EditCharterResolve],
})
export class EditCharterModule {}
